import CT from '@marketplace-ai/tags';

export const LICENSES_TABS = [
  {
    name: 'DEA Licenses',
    current: true,
    type: 'dea',
    cyTag: CT.account.tabs.DeaTab,
  },
  {
    name: 'CDS Licenses',
    current: false,
    type: 'cds',
    cyTag: CT.account.tabs.CdsTab,
  },
];
